import { Group, Text, createStyles } from '@mantine/core';
import { NavLink as RouterNavLink } from 'react-router-dom';
import type { ReactNode } from 'react';

interface NavLinkItemProps {
  to: string;
  icon?: ReactNode;
  children: ReactNode;
  end?: boolean;
}

const useStyles = createStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: theme.colors.gray[7],
    padding: '6px 12px',
    borderRadius: theme.radius.md,
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'background-color 0.15s ease, color 0.15s ease',

    '&:hover': {
      backgroundColor: theme.colors.gray[0],
      color: theme.colors.gray[9],
    },
  },

  active: {
    color: theme.colors.bagel[7],
    backgroundColor: theme.colors.bagel[0],
    fontWeight: 600,

    '&:hover': {
      backgroundColor: theme.colors.bagel[1],
      color: theme.colors.bagel[7],
    },
  },
}));

export function NavLinkItem({ to, icon, children, end }: NavLinkItemProps) {
  const { classes, cx } = useStyles();
  return (
    <RouterNavLink
      to={to}
      end={end}
      className={({ isActive }) => cx(classes.link, isActive && classes.active)}
    >
      <Group spacing={6} noWrap>
        {icon}
        <Text size="sm" inherit>
          {children}
        </Text>
      </Group>
    </RouterNavLink>
  );
}
